<script>
import { Bar } from 'vue-chartjs'
// const { reactiveProp } = mixins


export default {
	extends: Bar,
	//mixins: [reactiveProp],
    // props: ['options'],

	mounted () {
		let options = {
			scales: {
				yAxes: [{
					ticks: {
						beginAtZero: true
					}
				}]
			}
		}

		// this.chartData is created in the mixin.
		// If you want to pass options please create a local options object
		this.renderChart(this.chartData, options)
	}
}
</script>
